"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _commons = require("@focaltec-suite/commons");
var _core = require("@focaltec-suite/core");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function AllocationPartForm(_ref) {
  var allocation = _ref.allocation,
    current = _ref.current,
    maxPercentage = _ref.maxPercentage,
    allocationConfiguration = _ref.allocationConfiguration,
    costCenters = _ref.costCenters,
    catalogs = _ref.catalogs,
    disabled = _ref.disabled,
    onUpdated = _ref.onUpdated,
    onClose = _ref.onClose;
  var _a;
  var _useValidatedForm = (0, _commons.useValidatedForm)(),
    isValid = _useValidatedForm.isValid,
    register = _useValidatedForm.register,
    bind = _useValidatedForm.bind;
  var _useState = (0, _react.useState)((_a = current === null || current === void 0 ? void 0 : current.catalogs) !== null && _a !== void 0 ? _a : {}),
    _useState2 = _slicedToArray(_useState, 2),
    allocationCatalogs = _useState2[0],
    setAllocationCatalogs = _useState2[1];
  var max = (0, _react.useMemo)(function () {
    var _a;
    return maxPercentage + ((_a = current === null || current === void 0 ? void 0 : current.percentage) !== null && _a !== void 0 ? _a : 0);
  }, [maxPercentage, current]);
  var gtZeroValidator = (0, _react.useMemo)(function () {
    return new _commons.GTZeroValidator();
  }, []);
  var lteValidator = (0, _react.useMemo)(function () {
    return new _commons.LTEValidator(max);
  }, [max]);
  var costCentersOptions = (0, _react.useMemo)(function () {
    return costCenters.map(function (costCenter) {
      return {
        value: costCenter.id,
        label: costCenter.name
      };
    });
  }, [costCenters]);
  var catalogsOptions = (0, _react.useMemo)(function () {
    var map = {};
    catalogs.forEach(function (catalog) {
      map[catalog.id] = catalog.values.map(function (el) {
        return {
          value: el.external_id,
          label: el.label
        };
      });
    });
    return map;
  }, [catalogs]);
  var onSubmit = function onSubmit() {
    if (!isValid()) return;
    var request = Object.assign(Object.assign({}, bind()), {
      catalogs: allocationCatalogs
    });
    onUpdated(request);
  };
  var hasChangedCatalog = function hasChangedCatalog(catalogId, value) {
    setAllocationCatalogs(Object.assign(Object.assign({}, allocationCatalogs), _defineProperty({}, catalogId, value !== null && value !== void 0 ? value : '')));
  };
  return /*#__PURE__*/_react["default"].createElement(_commons.DialogPopup, {
    title: (0, _core.translate)('allocations.part'),
    onClose: onClose,
    button: {
      text: (0, _core.translate)('buttons.add'),
      onClick: onSubmit,
      disabled: disabled
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12,
    sx: allocationConfiguration.require_cost_center ? undefined : {
      display: 'none'
    }
  }, /*#__PURE__*/_react["default"].createElement(_commons.AnyAutocomplete, {
    name: "cost_center_id",
    label: (0, _core.translate)('cost_centers.single'),
    initialValue: current === null || current === void 0 ? void 0 : current.cost_center_id,
    options: costCentersOptions,
    required: allocationConfiguration.require_cost_center,
    disabled: !!allocation && !!current,
    register: register
  })), allocationConfiguration.catalogs.map(function (acCatalog) {
    var _a, _b, _c;
    return /*#__PURE__*/_react["default"].createElement(_material.Grid, {
      key: acCatalog.catalog_id,
      item: true,
      xs: 12
    }, /*#__PURE__*/_react["default"].createElement(_commons.AnyAutocomplete, {
      name: acCatalog.catalog_id,
      label: (_b = (_a = catalogs.find(function (catalog) {
        return catalog.id === acCatalog.catalog_id;
      })) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : acCatalog.catalog_id,
      initialValue: allocationCatalogs[acCatalog.catalog_id],
      options: (_c = catalogsOptions[acCatalog.catalog_id]) !== null && _c !== void 0 ? _c : [],
      required: true,
      disabled: !!allocation && !!current,
      register: register,
      notifier: hasChangedCatalog
    }));
  }), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_commons.AnyInput, {
    type: "number",
    name: "percentage",
    initialValue: current === null || current === void 0 ? void 0 : current.percentage,
    label: (0, _core.translate)('allocations.percentage'),
    required: true,
    validators: [gtZeroValidator, lteValidator],
    register: register,
    disabled: disabled
  }), /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "caption",
    component: "h6",
    textAlign: "right",
    color: "textSecondary",
    sx: {
      mt: 1
    }
  }, (0, _core.translate)('allocations.max', {
    max: (0, _commons.formatNumber)({
      value: max
    })
  })))));
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(AllocationPartForm);